
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/app",
      function () {
        return require("private-next-pages/[locale]/app/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/app"])
      });
    }
  